import { action } from '@reatom/framework'

import type { AvgPricesRequestParams } from '@root/entities/pair/atoms/avg-prices-request-action'

// eslint-disable-next-line @reatom/unit-naming-rule
export const reatomFilterByWalletEvent = action<
  AvgPricesRequestParams | undefined
>('reatomFilterByWalletEvent')
